import { render, staticRenderFns } from "./stuAllocate.vue?vue&type=template&id=9b595212&scoped=true"
import script from "./stuAllocate.vue?vue&type=script&lang=js"
export * from "./stuAllocate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b595212",
  null
  
)

export default component.exports